module.exports = __webpack_public_path__ + "img/newtaiyo7.9fddac33.png";